import Typograf from 'typograf'
import {LangObject} from "@brg/api/dist/api-core/utils/lang-utils";

const tp = new Typograf({locale: ['ru', 'en-US']});

export const executeTypograf = (rawText: string) => {
    return tp.execute(rawText)
}

export const executeTypografLangObject = (text: LangObject[]) => {
    return text.map(item => ({...item, name: tp.execute(item?.name || '')}))
}

export const executeTypografValue = <T>(value: T): T => {
    if (typeof value === 'string') {
        return executeTypograf(value) as unknown as T
    }

    if (Array.isArray(value)) {
        return executeTypografLangObject(value as unknown as LangObject[]) as unknown as T
    }

    return value
}
import Typograf from 'typograf'
import {LangObject} from "@brg/api/dist/api-core/utils/lang-utils";

const tp = new Typograf({locale: ['ru', 'en-US']});

export const executeTypograf = (rawText: string) => {
    return tp.execute(rawText)
}

export const executeTypografLangObject = (text: LangObject[]) => {
    return text.map(item => ({...item, name: tp.execute(item?.name || '')}))
}

export const executeTypografValue = <T>(value: T): T => {
    if (typeof value === 'string') {
        return executeTypograf(value) as unknown as T
    }

    if (Array.isArray(value)) {
        return executeTypografLangObject(value as unknown as LangObject[]) as unknown as T
    }

    return value
}
